/**
 * 見積り乖離表示の更新に関するフック
 */
import { useCallback } from 'react'
import { CellValueChangedEvent, IRowNode } from 'ag-grid-community'
import { ProductBacklogRow, isProductBacklogItemRow } from '../productBacklog'
import {
  FIELD_WBSITEM_ESTIMATED_WORKLOAD_DELIVERABLE,
  FIELD_WBSITEM_ESTIMATED_WORKLOAD_DELIVERABLE_PER_SPRINT,
} from '../gridOptions/columnDefs'

/**
 * 見積り列編集時に同一成果物の全行のcellStyleを再評価するハンドラ
 */
export const useEstimateVarianceHandler = () => {
  return useCallback((e: CellValueChangedEvent<ProductBacklogRow>) => {
    const colId = e.column.getColId()
    const isEstimateColumn =
      colId === FIELD_WBSITEM_ESTIMATED_WORKLOAD_DELIVERABLE_PER_SPRINT ||
      colId === FIELD_WBSITEM_ESTIMATED_WORKLOAD_DELIVERABLE
    if (!isEstimateColumn) return

    const editedRow = e.data
    if (!editedRow || !isProductBacklogItemRow(editedRow)) return

    const rowNodesToRedraw: IRowNode<ProductBacklogRow>[] = []
    e.api?.forEachNode(node => {
      if (
        node.data &&
        isProductBacklogItemRow(node.data) &&
        node.data.originalUuid === editedRow.originalUuid
      ) {
        rowNodesToRedraw.push(node)
      }
    })
    if (rowNodesToRedraw.length > 0) {
      e.api?.redrawRows({ rowNodes: rowNodesToRedraw })
    }
  }, [])
}
